import { useCallback, useState } from "react";

export const useTtlCounter = (tllInSeconds: number) => {
    const [count, setCount] = useState(0);

    const deduct = useCallback(() => {
        setCount((prevCount) => prevCount - 1);
    }, [setCount]);

    const addToCounter = useCallback(() => {
        setCount((prevCount) => prevCount + 1);

        setTimeout(deduct, tllInSeconds * 1000);
    }, [deduct, setCount]);

    return {
        addToCounter,
        count,
    };
};
